export const GADemoStandEvent = {
  PLAYER_FILTER_CLICKS: 'player_filter_clicks',
  SLOT_PLAYER_COUNTRY_CLICKS: 'slot_player_country_clicks',
  LIVE_CASINO_PLAYER_COUNTRY_CLICKS: 'live_casino_player_country_clicks',
  SECTION_TOOLTIPS_CLICKS: 'section_tooltips_clicks',
  DEMO_STAND_CLICKS: 'demo_stand_clicks',
  GAME_CARD_CLICKS: 'game_card_clicks',
} as const;

export const GADemoStandDimensionName = {
  PLAYER_FILTER: 'player_filter',
  SLOT_PLAYER_COUNTRY: 'slot_player_country',
  LIVE_CASINO_PLAYER_COUNTRY: 'live_casino_player_country',
  SECTION_TOOLTIP: 'section_tooltip',
  DEMO_STAND: 'demo_stand',
  GAME_CARD: 'game_card',
} as const;

export const GACalculatorEvent = {
  CALCULATOR_TOOLTIPS_CLICKS: 'calculator_tooltips_clicks',
  CALCULATOR_CLICKS: 'calculator_clicks',
  MONTHLY_ACTIVE_PLAYERS_INPUT: 'monthly_active_players_input',
  MONTHLY_GGR_INPUT: 'monthly_ggr_input',
  MONTHLY_NGR_PERCENT_INPUT: 'monthly_ngr_percent_input',
  MONTHLY_NGR_EUR_INPUT: 'monthly_ngr_eur_input',
  MONTHLY_HOURS_SPENT_INPUT: 'monthly_hours_spent_input',
  MANAGERS_HOURLY_RATE_INPUT: 'managers_hourly_rate_input',
  MONTHLY_ACTIVE_PLAYERS_SLIDER: 'monthly_active_players_slider',
  MONTHLY_GGR_SLIDER: 'monthly_ggr_slider',
  MONTHLY_NGR_PERCENT_SLIDER: 'monthly_ngr_percent_slider',
  MONTHLY_NGR_EUR_SLIDER: 'monthly_ngr_eur_slider',
  MONTHLY_HOURS_SPENT_SLIDER: 'monthly_hours_spent_slider',
  MANAGERS_HOURLY_RATE_SLIDER: 'managers_hourly_rate_slider',
} as const;

export const GACalculatorDimensionName = {
  CALCULATOR_TOOLTIP: 'calculator_tooltip',
  CALCULATOR: 'calculator',
  MONTHLY_ACTIVE_PLAYERS: 'monthly_active_players',
  MONTHLY_GGR: 'monthly_ggr',
  MONTHLY_NGR_PERCENT: 'monthly_ngr_percent',
  MONTHLY_NGR_EUR: 'monthly_ngr_eur',
  MONTHLY_HOURS_SPENT: 'monthly_hours_spent',
  MANAGERS_HOURLY_RATE: 'managers_hourly_rate',
} as const;

export const GAOverviewEvent = {
  SEARCH_INPUT: 'overview_search_input',
  SHOW_INACTIVE_CHECKBOX: 'overview_show_inactive_checkbox',
  ENV_DROPDOWN: 'overview_env_dropdown',
  TABLE_SORTINGS: 'overview_table_sortings',
  TABLE_FILTERS: 'overview_table_filters',
  TABLE_TOOLTIP_CLICKS: 'overview_table_tooltips_clicks',
  TABLE_CLICK: 'overview_table_clicks',
} as const;

export const GAOverviewDimensionName = {
  SEARCH: 'overview_search',
  SHOW_INACTIVE: 'overview_show_inactive',
  ENV: 'overview_env',
  TABLE_SORTING: 'overview_table_sorting',
  TABLE_FILTER: 'overview_table_filter',
  TABLE_TOOLTIP: 'overview_table_tooltip',
  TABLE: 'overview_table',
} as const;

export const GAGettingStartedEvent = {
  CLICKS: 'getting_started_clicks',
} as const;

export const GAGettingStartedDimensionName = {
  GETTING_STARTED: 'getting_started',
} as const;

export const GAIntegrationGuideEvent = {
  CLICKS: 'integration_guide_clicks',
} as const;

export const GAIntegrationGuideDimensionName = {
  INTEGRATION_GUIDE: 'integration_guide',
} as const;

export const GAIntegrationEvent = {
  ENV_SWITCH: 'integration_env_switch',
} as const;

export const GAIntegrationDimensionName = {
  ENVIRONMENT: 'environment',
} as const;

export const GAIntegrationDataUploadEvent = {
  CLICKS: 'integration_data_upload_clicks',
  CREDS_CLICKS: 'integration_data_upload_creds_clicks',
} as const;

export const GAIntegrationDataUploadDimensionName = {
  INTEGRATION_DATA_UPLOAD: 'integration_data_upload',
  CREDS_COPY_KEY: 'creds_copy_key',
  CREDS_TOGGLE_KEY_VISIBILITY: 'creds_toggle_key_visibility',
} as const;

export const GAIntegrationRecsApiEvent = {
  CLICKS: 'integration_recs_api_clicks',
  CREDS_CLICKS: 'integration_recs_api_creds_clicks',
  SEARCH_INPUT: 'integration_recs_api_search_input',
  TABLE_CLICKS: 'integration_recs_api_table_clicks',
} as const;

export const GAIntegrationRecsApiDimensionName = {
  INTEGRATION_RECS_API: 'integration_recs_api',
  CREDS_COPY_KEY: 'creds_copy_key',
  CREDS_TOGGLE_KEY_VISIBILITY: 'creds_toggle_key_visibility',
  SEARCH: 'integration_recs_api_search',
  TABLE: 'integration_recs_api_table',
} as const;

export const GAIntegrationEventsEvent = {
  CLICKS: 'integration_events_clicks',
  CREDS_CLICKS: 'integration_events_creds_clicks',
  SEARCH_INPUT: 'integration_events_search_input',
  TABLE_CLICKS: 'integration_events_table_clicks',
  TABLE_SORTINGS: 'integration_events_table_sortings',
} as const;

export const GAIntegrationEventsDimensionName = {
  INTEGRATION_EVENTS: 'integration_events',
  CREDS_COPY_KEY: 'creds_copy_key',
  CREDS_TOGGLE_KEY_VISIBILITY: 'creds_toggle_key_visibility',
  SEARCH: 'integration_events_search',
  TABLE: 'integration_events_table',
  TABLE_SORTING: 'integration_events_table_sorting',
} as const;

export const GAGamePromotionEvent = {
  SEARCH_INPUT: 'game_promotion_search_input',
  CLICKS: 'game_promotion_clicks',
  TOOLTIP_CLICKS: 'game_promotion_tooltip_clicks',
  COUNTRIES_CLICKS: 'game_promotion_clicks',
  COUNTRIES_FILTERS: 'game_promotion_countries_filters',
  COUNTRIES_SORTINGS: 'game_promotion_countries_sortings',
  TABLE_CLICKS: 'game_promotion_table_clicks',
  TABLE_FILTERS: 'game_promotion_table_filters',
  TABLE_SORTINGS: 'game_promotion_table_sortings',
  PIN_CLICKS: 'game_promotion_pin_clicks',
} as const;

export const GAGamePromotionDimensionName = {
  SEARCH: 'game_promotion_search',
  TOOLTIP: 'game_promotion_tooltip',
  MAIN_PAGE: 'game_promotion_main_page',
  BRAND_PAGE: 'game_promotion_brand_page',
  COUNTRIES: 'game_promotion_countries',
  COUNTRY: 'game_promotion_country',
  COUNTRIES_FILTER: 'game_promotion_countries_filter',
  COUNTRIES_SORTING: 'game_promotion_countries_sorting',
  TABLE: 'game_promotion_table',
  TABLE_FILTER: 'game_promotion_table_filter',
  TABLE_SORTING: 'game_promotion_table_sorting',
  PIN: 'game_promotion_pin',
} as const;

export const GARecommendationsEvent = {
  SEARCH_INPUT: 'recommendations_search_input',
  ENV_DROPDOWN: 'recommendations_env_dropdown',
  CLICKS: 'recommendations_clicks',
  SECTIONS_CLICKS: 'recommendations_sections_clicks',
  PLAYERS_SEARCH_INPUT: 'recommendations_player_search_input',
  PROVIDER_SELECT: 'recommendations_provider_select',
  GAME_SELECT: 'recommendations_game_select',
  COUNTRY_SELECT: 'recommendations_country_select',
} as const;

export const GARecommendationsDimensionName = {
  SEARCH: 'recommendations_search',
  ENV: 'recommendations_env',
  MAIN_PAGE: 'recommendations_main_page',
  BRAND_PAGE: 'recommendations_brand_page',
  SECTION: 'recommendations_section',
  PLAYERS_SEARCH: 'recommendations_player_search',
  PROVIDER: 'recommendations_provider',
  GAME: 'recommendations_game',
  COUNTRY: 'recommendations_country',
} as const;

export const GAAnalyticsEvent = {
  SEARCH_INPUT: 'analytics_search_input',
  SHOW_INACTIVE_CHECKBOX: 'analytics_show_inactive_checkbox',
  CLICKS: 'analytics_clicks',
  SECTION_PLAYER_SEARCH_INPUT: 'analytics_section_player_search_input',
  SECTION_CURRENCY_SELECT: 'analytics_section_currency_select',
  SECTION_MONEY_TYPE_SELECT: 'analytics_section_money_type_select',
  SECTION_GAME_TYPE_SELECT: 'analytics_section_game_type_select',
  SECTION_COUNTRY_SELECT: 'analytics_section_country_select',
  SECTION_RANGE_PRESET_RADIO: 'analytics_section_range_preset_radio',
  SECTION_RANGE_PRESET_DATEPICKER: 'analytics_section_range_preset_datepicker',
  SECTION_TOOLTIPS_CLICKS: 'analytics_section_tooltips_clicks',
  SECTION_TABLE_SORTINGS: 'analytics_section_table_sortings',
  GAME_CLICKS: 'analytics_game_clicks',
  GAME_PLAYER_SEARCH_INPUT: 'analytics_game_player_search_input',
  GAME_CURRENCY_SELECT: 'analytics_game_currency_select',
  GAME_MONEY_TYPE_SELECT: 'analytics_game_money_type_select',
  GAME_PROVIDER_SELECT: 'analytics_game_provider_select',
  GAME_GAME_SELECT: 'analytics_game_game_select',
  GAME_GAME_TYPE_SELECT: 'analytics_game_game_type_select',
  GAME_COUNTRY_SELECT: 'analytics_game_country_select',
  GAME_TOOLTIPS_CLICKS: 'analytics_game_tooltips_clicks',
  GAME_RANGE_PRESET_RADIO: 'analytics_game_range_preset_radio',
  GAME_RANGE_PRESET_DATEPICKER: 'analytics_game_range_preset_datepicker',
  GAME_TABLE_SORTINGS: 'analytics_game_table_sortings',
  GAME_TABLE_CLICKS: 'analytics_game_table_clicks',
  GAME_TABLE_TOOLTIPS_CLICKS: 'analytics_game_table_tooltips_clicks',
  AB_CLICKS: 'analytics_ab_clicks',
  AB_TOOLTIP_CLICKS: 'analytics_ab_tooltips_clicks',
  AB_RANGE_PRESET_RADIO: 'analytics_ab_range_preset_radio',
  AB_RANGE_PRESET_DATEPICKER: 'analytics_ab_range_preset_datepicker',
  AB_TURNOVER_PERCENTILE_SELECT: 'analytics_ab_turnover_percentile_select',
  AB_BETS_PERCENTILE_SELECT: 'analytics_ab_bets_percentile_select',
  AB_GLOBAL_PERCENTILE_SELECT: 'analytics_ab_global_percentile_select',
  AB_GLOBAL_MONEY_TYPE_SELECT: 'analytics_ab_global_money_type_select',
  AB_GLOBAL_CURRENCY_SELECT: 'analytics_ab_global_currency_select',
  AB_TESTING_CLICKS: 'ab_testing_clicks',
} as const;

export const GAAnalyticsDimensionName = {
  SEARCH: 'analytics_search',
  SHOW_INACTIVE: 'analytics_show_inactive',
  MAIN_PAGE: 'analytics_main_page',
  BRAND_PAGE: 'analytics_brand_page',
  SECTION_PLAYER_SEARCH: 'analytics_section_player_search',
  SECTION_CURRENCY: 'analytics_section_currency',
  SECTION_MONEY_TYPE: 'analytics_section_money_type',
  SECTION_GAME_TYPE: 'analytics_section_game_type',
  SECTION_COUNTRY: 'analytics_section_country',
  SECTION_RANGE_PRESET: 'analytics_section_range_preset',
  SECTION_TOOLTIP: 'analytics_section_tooltip',
  SECTION_TABLE_SORTING: 'analytics_section_table_sorting',
  GAME: 'analytics_game',
  GAME_PLAYER_SEARCH: 'analytics_game_player_search',
  GAME_CURRENCY: 'analytics_game_currency',
  GAME_MONEY_TYPE: 'analytics_game_money_type',
  GAME_PROVIDER: 'analytics_game_provider',
  GAME_GAME: 'analytics_game_game',
  GAME_GAME_TYPE: 'analytics_game_game_type',
  GAME_COUNTRY: 'analytics_game_country',
  GAME_TOOLTIP: 'analytics_game_tooltip',
  GAME_RANGE_PRESET: 'analytics_game_range_preset',
  GAME_TABLE_SORTING: 'analytics_game_table_sorting',
  GAME_TABLE: 'analytics_game_table',
  GAME_TABLE_TOOLTIP: 'analytics_game_table_tooltip',
  AB: 'analytics_ab',
  AB_TOOLTIP: 'analytics_ab_tooltip',
  AB_RANGE_PRESET: 'analytics_ab_range_preset',
  AB_TURNOVER_PERCENTILE: 'analytics_ab_turnover_percentile',
  AB_BETS_PERCENTILE: 'analytics_ab_bets_percentile',
  AB_GLOBAL_PERCENTILE: 'global_percentile',
  AB_GLOBAL_MONEY_TYPE: 'global_money_type',
  AB_GLOBAL_CURRENCY: 'global_currency',
} as const;

export const GAHeaderEvent = {
  HEADER_CLICKS: 'header_clicks',
} as const;

export const GAHeaderDimensionName = {
  HEADER: 'header',
} as const;

export const GASignInEvent = {
  SIGN_IN_CLICKS: 'sign_in_clicks',
} as const;

export const GASignInDimensionName = {
  SIGN_IN: 'sign_in',
} as const;

export const GAChurnEvent = {
  CHURN_CLICKS: 'churn_clicks',
  CHURN_EXPORT_CLICK: 'churn_export_click',
  CHURN_SORTING_CLICK: 'churn_sorting_click',
  CHURN_PLAYER_SEARCH_INPUT: 'churn_player_search_input',
  CHURN_EXPLAINER_CLICK: 'churn_rate_explainer_click',
  CHURN_PREDICITON_INPUT: 'churn_prediction_input',
  CHURNED_PLAYERS_CHECKBOX: 'churned_players_checkbox',
} as const;

export const GAChurnDimensionName = {
  PREDICTION_VALUE: 'prediction_value',
} as const;

export const GADataUploadEvent = {
  DATA_UPLOAD_CLICKS: 'data_upload_clicks',
  DATA_UPLOAD_CHECK_NEW_FILES_CLICK: 'data_upload_check_new_files_click',
  DATA_UPLOAD_ERROR_VIEW: 'data_upload_error_view',
  DATA_UPLOAD_ENV_SWITCH: 'data_upload_env_switch',
} as const;

export const GAGameCollectionEvent = {
  GAME_COLLECTION_COUNTRY_SELECT: 'game_collection_country_select',
  GAME_COLLECTION_PROVIDER_SELECT: 'game_collection_provider_select',
  GAME_COLLECTION_GAME_TYPE_SELECT: 'game_collection_game_type_select',
  GAME_COLLECTION_FEATURES_SELECT: 'game_collection_features_select',
  GAME_COLLECTION_FEATURES_OP_SELECT: 'game_collection_features_op_select',
  GAME_COLLECTION_THEMES_SELECT: 'game_collection_themes_select',
  GAME_COLLECTION_THEMES_OP_SELECT: 'game_collection_themes_op_select',
  GAME_COLLECTION_CLEAR_FILTERS: 'game_collection_clear_filters',
  GAME_COLLECTION_DOCS_CLICK: 'game_collection_docs_click',
  GAME_COLLECTION_EXPORT_CLICK: 'game_collection_export_click',
  GAME_COLLECTION_GET_CURL_CLICK: 'game_collection_get_curl_click',
  GAME_COLLECTION_UNPIN_CLICK: 'game_collection_unpin_click',
  GAME_COLLECTION_PIN_MODAL_OPEN: 'game_collection_pin_modal_open',
  GAME_COLLECTION_PIN_SEARCH_INPUT: 'game_collection_pin_search_input',
  GAME_COLLECTION_PIN_ADD: 'game_collection_pin_add',
  GAME_COLLECTION_PIN_REMOVE: 'game_collection_pin_remove',
  GAME_COLLECTION_PIN_CONFIRM: 'game_collection_pin_confirm',
  GAME_COLLECTION_PIN_CANCEL: 'game_collection_pin_cancel',
  GAME_COLLECTION_DND: 'game_collection_dnd',
} as const;

export const GAGameCollectionDimensionName = {
  COUNTRY_ID: 'country_id',
  PROVIDER_ID: 'provider_id',
  GAME_TYPE_ID: 'game_type_id',
  FEATURE_ID: 'feature_id',
  THEME_ID: 'theme_id',
  GAME_ID: 'game_id',
  QUERY: 'query',
  OP_ID: 'op_id',
} as const;

export const GACostOptimizationEvent = {
  CLICKS: 'co_clicks',
  TABLE: 'co_table',
  SEARCH_INPUT: 'co_search_input',
} as const;

export const GACostOptimizationDimensionName = {
  CO_CLICK: 'co_click',
  COUNTRY_CLICK: 'country_click',
  SEARCH_CLICK: 'search_click',
  RESET_CLICK: 'reset_click',
  TABLE_CLICK: 'table_click',
  SEARCH: 'search',
  LOAD_MORE_GAMES: 'load_more_games',
  GAME_LEVEL_CHANGE: 'game_level_change',
  GAME_ID: 'game_id',
  PROVIDER_LEVEL_CHANGE: 'provider_level_change',
  PROVIDER_ID: 'provider_id',
  EXPAND_PROVIDER: 'expand_provider',
  COLLAPSE_PROVIDER: 'collapse_provider',
} as const;
